/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import axios from 'axios';
import api from './api.services';
import {fetchApiDataFailure} from "../_actions/common.actions";
import {showMessage} from "../_actions/message.actions";
import {fetchVitalsourceCollectionSuccess, setVSbookAvailabilityInStoreSuccess} from "../_actions/vitalsource.publish.action";

export const updateSubscriptionLength = (collectionId) => (dispatch, getState) => {
    axios.put(api.update_vs_subscriptionLength.replace('{collection-id}', collectionId).replace('{subscriptionLength}', getState().vitalsourceStatuses.subscriptionLength))
        .then(response => {
            dispatch(showMessage({messageKey: 'default_success', type: 'success' }));
        })
        .catch(error => {
            dispatch(showMessage({messageKey: 'default_failed', type: 'error' }));
        });
};

export const getVitalsourceCollectionInfo = (collectionId) => dispatch => {
    axios.get(api.get_vitalsource_collection_info.replace('{collection-id}', collectionId))
        .then(response => {
            dispatch(fetchVitalsourceCollectionSuccess(response.data));
            if(response.data && response.data.inviteLink) {
                dispatch(checkVSBookInStore(collectionId, response.data.inviteLink));
            }
        })
        .catch(error => {
            dispatch(fetchApiDataFailure(error));
        });

};

export const checkVSBookInStore = (collectionId, wlsLink) => dispatch => {
    axios.get(api.check_vs_book_in_wls.replace('{collection-id}', collectionId).replace('{wlsLink}', wlsLink))
        .then(response => {
            dispatch(setVSbookAvailabilityInStoreSuccess(response.status));
        });
};


// WEBPACK FOOTER //
// ./src/_thunks/vitalsource.thunk.js